import Users from '../../../store/users';

angular
    .module('festzelt-os.modules.users')
    .factory('Users', [
        '$injector',
        'User',
        ($injector, User) => new Users(User, {
            injector: $injector
        })
    ]);



// WEBPACK FOOTER //
// ./src/app/modules/users/store/users.js